import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Faq, FaqSection } from '../../../classes/http-responses';
import { GeneralQuestionsItemComponent } from './general-questions-item/general-questions-item.component';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'general-questions',
	template: require('./general-questions.component.html'),
})
export class GeneralQuestionsComponent implements OnInit {
	@Input() section: FaqSection;
	public isRebrading = AppSettings.isRebrading;
	public faqs: Faq[];
	public searchTerm: string;
	constructor(private activeModalService: NgbActiveModal, private modalService: NgbModal) {}

	ngOnInit(): void {
		this.setSearch(null);
	}

	setSearch(term: string) {
		this.faqs = this.section.search(term);
	}

	closeModal() {
		this.activeModalService.close();
	}

	toggleModal(faq: Faq): void {
		this.closeModal();
		let modalRef = this.modalService.open(GeneralQuestionsItemComponent, {
			windowClass: 'modal-small',
		});
		modalRef.componentInstance.faq = faq;
		modalRef.componentInstance.faqSection = this.section;
	}
}
